import React, {
  FC
} from 'react';

import {
  termsAndConditions
} from './utils';
import {
  ContentLayout
} from './ui';

export const TermOfServices: FC = () => {
  return <ContentLayout links={termsAndConditions} />;
};
